module.exports = __webpack_public_path__ + "static/media/rubk-logo.f1dde625.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/development/assets/images/rubk-logo.svg
// module id = 260
// module chunks = 0